import { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AtOutline } from '@lyearn/icons';
import { IconButton, Tooltip } from '@lyearn/ui';
import { ToolbarButtonProps } from '@/components/Editor/PlainEditor/types';
import onMentionButtonClick from '@/modules/corporate/modules/channel/views/ChannelDetails/hooks/useMessageInput/utils/onMentionButtonClick';

const AddMentionOption: React.FC<ToolbarButtonProps> = (props) => {
  const { editorView } = props;
  const { t } = useTranslation();

  const onClick = useCallback(() => {
    onMentionButtonClick(editorView);
  }, [editorView]);

  return (
    <Tooltip placement="bottom" title={t('Common:Message.AddMention')!}>
      <IconButton
        Icon={AtOutline}
        appearance="secondary"
        className="me-4"
        shape="square"
        size="s"
        variant="ghost"
        onClick={onClick}
      />
    </Tooltip>
  );
};

export default AddMentionOption;
